import CustomTable from '../../../../../components/table/CustomTable';
import RequestStatusCard from './RequestStatusCard';
import DividerWithText from '../../../../../components/DividerWithText';
import { REQUEST_STATUS } from '../Model/Models';
import HistoryTableApp from "../Functionality/HistoryTableApp";
import RequestMealSubHeader from "./RequestMealSubHeader";
import React from "react";
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const HistoryTab = (props) => {
    const {
        subView,
        userTypeId,
        searchElement,
        setSearchElement,
        activeStep,
        modified,
        setModified,
        setItemSelected,
        setShowSummaryModal,
        handleDownload,
        handleShowActive,
        handleShowHistory,
        option,
        setBodyForExport,
        setSearch,
        simpleSearch,
        setSimpleSearch,
    } = props;

    const {
        t,
        tableId,
        searchId,
        tbody,
        thead,
        status,
        results,
        setResults,
        page,
        rowsPerPage,
        getActionsButtons,
        handleCheckboxChange,
        pagination,
        getData
    } = HistoryTableApp({
        modified,
        setModified,
        setItemSelected,
        searchElement,
        setShowSummaryModal,
        handleDownload,
        option,
        setBodyForExport
    });

    const hasContent = tbody?.data && tbody.data.length > 0;

    return (<>
            <RequestMealSubHeader
                subView={subView}
                handleShowActive={handleShowActive}
                handleShowHistory={handleShowHistory}
                searchId={searchId}
                setBodyForExport={setBodyForExport}
                results={results}
                setResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                getData={getData}
                userTypeId={userTypeId}
                activeStep={activeStep}
                page={page}
            />
            <div className={'row'}>

            {hasContent && (
                <>
                    <DividerWithText title={t('overview')} spacing={'my-2'} />
                    <RequestStatusCard
                        status={status}
                        statusToShow={[REQUEST_STATUS.APPROVED.id, REQUEST_STATUS.DENIED.id]}
                    />
                </>
            )}
            <CustomTable
                tableId={tableId}
                searchId={searchId}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                handleCheckboxChange={handleCheckboxChange}
                childrenNotInformation={tbody?.data?.length === 0 ? <>
                        <div className={"warning-text"}>
                            <p>{t("you_have_not_created_requests_yet")}</p>
                        </div>
                    </>
                    : undefined
                }
            />

            {pagination()}
        </div>
        </>
    );
};

export default HistoryTab;
